import React from 'react'
import Breadcrumbs from '../../components/Breadcrumbs'
import './styles.css'

const Contato = ({ children, page }) => {
  return (
    <>
      <Breadcrumbs
        pages={[
          {
            title: page.title,
            url: page.slug
          }
        ]}
      />
      <div className='page-container'>
        {children}
      </div>
    </>
  )
}

export default Contato
